module.exports = __webpack_public_path__ + "img/2.c67b703e.png";